export default "__VITE_ASSET__h5bGCQ4n__"